import React, { useMemo } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import * as icons from '~/assets/icons'

type Icon = keyof typeof icons
type BadgeType = 'error' | 'success' | 'info' | 'warning'

export type BadgeContainerProps = {
  icon?: Icon,
  title?: string,
  type: BadgeType,
  description?: string,
  iconComponent?: JSX.Element
}

const useStyles = makeStyles({
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: mutualTheme.spacing(4),
    color: mutualTheme.palette.common.white,
    [mutualTheme.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    }
  },
  itemInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: mutualTheme.spacing(1),
    marginLeft: mutualTheme.spacing(1),
    [mutualTheme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: mutualTheme.spacing(0)
    }
  },
  itemTitle: {
    fontWeight: 500
  },
  itemValue: {
    fontWeight: 800
  }
})

export const BadgeContainer: React.FC<BadgeContainerProps> = (props) => {
  const { children, title, description, icon, type, iconComponent } = props
  const classes = useStyles()

  const Icon = useMemo(() => icons[icon || 'CalendarIcon'], [icon])

  const innerContainer = useMemo(() => {
    return children || (
      <>
        <Typography variant='airbnbBody1' className={classes.itemTitle}>{title}</Typography>
        <Typography variant='airbnbBody1' className={classes.itemValue}>{description}</Typography>
      </>
    )
  }, [children, title, description])

  return (
    <Box className={classes.itemContainer}>
      {!iconComponent && <Icon htmlColor={mutualTheme.palette.badgeBackgroundColor[type].light} />}
      {iconComponent}
      <Box className={classes.itemInnerContainer}>
        {innerContainer}
      </Box>
    </Box>
  )
}
